/* eslint-disable @typescript-eslint/no-namespace */
import { Instant, PlainDateTime, PlainTime } from "@/Temporal"

declare module "temporal-spec" {
	export namespace Temporal {
		export interface PlainTime {
			toHTMLInput(): string
		}

		export namespace Instant {
			let fromHtmlInputUTC: (input: string) => Instant
		}
		export interface Instant {
			toUTCDateTimeString(): string
			toHTMLInputUTC(): string
			compareTo(other: Instant): number
		}
	}
}

PlainTime.prototype.toHTMLInput = function () {
	return this.toString({ smallestUnit: "minute" })
}
PlainTime.prototype.toJSON = function () {
	return this.toString({ smallestUnit: "second" })
}

PlainDateTime.prototype.toJSON = function () {
	return this.toString({ smallestUnit: "second" })
}

Instant.prototype.toHTMLInputUTC = function () {
	return this.toZonedDateTimeISO("UTC").toPlainDateTime().toString({ smallestUnit: "minute" })
}
Instant.prototype.compareTo = function (other) {
	return Instant.compare(this, other)
}

const padNumber = (number: number, length: number) => number.toString().padStart(length, "0")
Instant.prototype.toUTCDateTimeString = function () {
	const time = this.toZonedDateTimeISO("UTC").toPlainDateTime()
	const yr = padNumber(time.year, 4)
	const month = padNumber(time.month, 2)
	const day = padNumber(time.day, 2)

	const hour = padNumber(time.hour, 2)
	const minute = padNumber(time.minute, 2)

	return `${yr}/${month}/${day} ${hour}:${minute}`
}
Instant.fromHtmlInputUTC = function (input: string): Instant {
	const dt = PlainDateTime.from(input)
	return dt.toZonedDateTime("UTC").toInstant()
}
